/**
 * @generated SignedSource<<7b07e0214ce80ea3898889917b3de6fe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type TownsquareProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader$data = {
  readonly dueDate: {
    readonly label: string | null;
  } | null;
  readonly iconUrl: {
    readonly square: {
      readonly dark: string | null;
      readonly light: string | null;
    } | null;
  } | null;
  readonly key: string;
  readonly name: string;
  readonly state: {
    readonly value: TownsquareProjectStateValue | null;
  } | null;
  readonly " $fragmentType": "projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader";
};
export type projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader$key = {
  readonly " $data"?: projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "projectStatusUpdateCardHeader_AtlassianConversationAssistantMessageActions_CardHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "TownsquareIconURIs",
      "kind": "LinkedField",
      "name": "iconUrl",
      "plural": false,
      "selections": [
        {
          "concreteType": "TownsquareThemeURIs",
          "kind": "LinkedField",
          "name": "square",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "light"
            },
            {
              "kind": "ScalarField",
              "name": "dark"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "TownsquareProjectState",
      "kind": "LinkedField",
      "name": "state",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    },
    {
      "concreteType": "TownsquareTargetDate",
      "kind": "LinkedField",
      "name": "dueDate",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "label"
        }
      ]
    }
  ],
  "type": "TownsquareProject"
};

(node as any).hash = "84a9297c972c839e664374b242fe5f52";

export default node;
